import { Button } from "react-bootstrap";
import { Address } from "../../Physician/Models/Address";
import { AddressVerificationResult } from "../../Physician/Models/AddressVerificationResult";

interface IProps {
    data: AddressVerificationResult;
    onUseAsEntered: () => void;
    onUseSuggested: () => void;
}


export default function AddressValidation(props: IProps) {
    var getAddressString = (address: Address) => {
        if (!address) return null;
        return `${address.line1}${address.line2 ? ", " + address.line2 : ""}, ${address.city}, ${address.stateCode} ${address.zipCode}`
    }
    if (props.data == null) return null;
    return (
        <div>
            <div>
                <span className="h6 font-weight-bold">Entered Address:</span>
                <span>{getAddressString(props.data.originalAddress)}</span>
            </div>
            <div hidden={!props.data.suggestedAddress}>
                <span className="h6 font-weight-bold">Suggested Address: </span>
                <span>{getAddressString(props.data.suggestedAddress)}</span>
            </div>
            <div hidden={props.data.suggestedAddress != null}>
                <span className="text-danger mr-2">Address could not be validated. Please correct the entry or Use As Entered</span>
            </div>
            <div className="mt-2">
                <Button type="button" variant="outline-pp-primary" className="align-self-center mr-2"
                    hidden={!props.data.suggestedAddress}
                    onClick={() => props.onUseSuggested()}>Use Suggested</Button>
                <Button type="button" variant="outline-pp-primary" className="align-self-center"
                    onClick={() => props.onUseAsEntered()}>Use As Entered</Button>
            </div>
        </div>
    );
}
